export const competitionStatus = {
  DRAFT: 'DRAFT',
  UNDER_APPROVAL: 'UNDER_APPROVAL',
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}

export const getReadableCompetitionStatus = id => {
  switch (id) {
    case competitionStatus.DRAFT:
      return 'Piszkozat'
    case competitionStatus.UNDER_APPROVAL:
      return 'Jóváhagyás alatt'
    case competitionStatus.APPROVED:
      return 'Jóváhagyva'
    case competitionStatus.ACTIVE:
      return 'Aktív'
    case competitionStatus.INACTIVE:
      return 'Inaktív'
  }
}
